import CalendarSchedules from '../../components/calendar-schedules/CalendarSchedules';

window.SchedulesView = function (options) {
	const _self = this;

	function _init () {
		new CalendarSchedules(options);
	}

	_init();
};
